module.exports = __webpack_public_path__ + "img/Gc.5967305a.png";